import axios from "axios";
import { apiUrl } from "./apiUrl";
const apiHeaders = {
  headers: {
    Accept: "application/json",
    Authorization: localStorage.getItem("AuthToken"),
  },
};

export function getOriginOnAirline(airline) {
  airline = `?airlineCode=${airline}`;
  return axios
    .get(apiUrl["getAirline"] + airline, apiHeaders)
    .then((resp) => resp)
    .catch((err) => err);
}

export function airlineSelect1(airline) {
  airline = `?airlineCode=${airline}`;
  return axios
    .get(apiUrl["getAirline1"] + airline)
    .then((resp) => resp)
    .catch((err) => err);
}

// Audit Log API functions
export function fetchFareRuleList() {
  const headers = {
    headers: {
      Accept: "application/json",
      Authorization: localStorage.getItem("AuthToken"),
    },
  };
  return axios.get(apiUrl.fareRuleList, headers).then((resp) => resp).catch((err) => err);
}

export function saveFareRule(payload) {
  const headers = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("AuthToken"),
    },
  };
  return axios.post(apiUrl.fareRuleSaveUpdate, payload, headers).then((resp) => resp).catch((err) => err);
}

export function getFareRule(ruleId) {
  const headers = {
    headers: {
      Accept: "application/json",
      Authorization: localStorage.getItem("AuthToken"),
    },
  };
  return axios.get(`${apiUrl.fareRuleGet}/${ruleId}`, headers).then((resp) => resp).catch((err) => err);
}

export function deleteFareRule(ruleId) {
  const headers = {
    headers: {
      Accept: "application/json",
      Authorization: localStorage.getItem("AuthToken"),
    },
  };
  return axios.delete(`${apiUrl.fareRuleDelete}/${ruleId}`, headers).then((resp) => resp).catch((err) => err);
}

export function fetchAuditLogs(params) {
  const queryParams = new URLSearchParams();
  
  if (params.tableName) queryParams.append('tableName', params.tableName);
  if (params.from) queryParams.append('from', params.from);
  if (params.to) queryParams.append('to', params.to);
  if (params.action) queryParams.append('action', params.action);
  if (params.clientId) queryParams.append('clientId', params.clientId);
  if (params.airlineCode) queryParams.append('airlineCode', params.airlineCode);
  if (params.page !== undefined) queryParams.append('page', params.page);
  if (params.size !== undefined) queryParams.append('size', params.size);

  const headers = {
    headers: {
      Accept: "application/json",
      Authorization: localStorage.getItem("AuthToken"),
    },
  };

  return axios
    .get(`${apiUrl.auditLogs}?${queryParams.toString()}`, headers)
    .then((resp) => resp)
    .catch((err) => err);
}
